/*
 * Orbe popup: only where this page exists on the recommended store, and then to that page.
 *
 * Orbe gives each country to one store. Its first-visit popup sends the visitor to that
 * store's HOME page, because full-path redirects are off (most product URLs differ between
 * the stores). This script uses the page's own hreflang links instead:
 *  - the popup opens only when the page has an alternate on the recommended store (a
 *    <link rel="alternate" hreflang> whose host is that store); a page without one shows
 *    no popup at all;
 *  - "Shop now" (and Orbe's own return-visit redirect) lands on that alternate page.
 *  - product pages never open the popup on their own (the snippet marks them with
 *    data-product-page); the country selector still opens it there.
 * Loaded by snippets/orbe-hreflang-routing.liquid above content_for_header, so it runs
 * before orbe.min.js (every script involved is deferred).
 *
 * How it hooks into Orbe 5.8–5.9:
 *  - Orbe copies mdApp_forceHideOrbe while it starts; processGeolocation() then skips the
 *    automatic open when it is true. The manual country selector is not affected.
 *  - On the first page of a tab session Orbe looks the country up (async) and then calls
 *    processGeolocation(); later pages reuse sessionStorage.orbeSession and call it at once,
 *    while orbe.min.js is still running. So with a cached session the decision is made
 *    here, before Orbe starts; without one, processGeolocation is wrapped as soon as
 *    orbe.min.js has run, before the lookup can answer.
 *  - Before a redirect Orbe fires "orbe:before-redirect" on window with detail.url and then
 *    navigates to whatever detail.url holds.
 */
(function () {
  var here = location.hostname;
  var productPage = !!(document.currentScript && document.currentScript.hasAttribute('data-product-page'));

  // host -> this page on that store (the first alternate per foreign host)
  var alternates = {};
  Array.prototype.forEach.call(document.querySelectorAll('link[rel="alternate"][hreflang][href]'), function (link) {
    var url;
    try {
      url = new URL(link.href, location.href);
    } catch (error) {
      return;
    }
    if (url.hostname !== here && !alternates[url.hostname]) alternates[url.hostname] = url.href;
  });

  // Orbe's preview (?showOrbe&orbe_preview_country=XX) stands in for the visitor's country
  var params = new URLSearchParams(location.search);
  var preview = params.has('showOrbe') ? (params.get('orbe_preview_country') || '').toUpperCase() : '';

  function hostFor(country) {
    var row =
      country &&
      document.querySelector('#orbeCountryList .md-form__select__country__list-link[data-country="' + country + '"]');
    return row ? row.dataset.host : '';
  }

  // May the popup open for a visitor from this country? Only if that country's store has
  // this page. The visitor's own store, or an unknown country, is left to Orbe's rules.
  function allowed(country) {
    var host = hostFor(preview || country);
    if (!host || host === here) return true;
    return !!alternates[host];
  }

  function wrapProcessGeolocation() {
    var Klass;
    try {
      Klass = typeof Orbe === 'function' ? Orbe : null;
    } catch (error) {
      Klass = null;
    }
    if (!Klass || !Klass.prototype.processGeolocation || Klass.prototype.processGeolocation.hreflangRouting) return false;
    var original = Klass.prototype.processGeolocation;
    var wrapped = function () {
      var hide = this.forceHideOrbe;
      if (!allowed(this.remoteCountryCode)) this.forceHideOrbe = true;
      try {
        return original.apply(this, arguments);
      } finally {
        this.forceHideOrbe = hide;
      }
    };
    wrapped.hreflangRouting = true;
    Klass.prototype.processGeolocation = wrapped;
    return true;
  }

  var cached = null;
  try {
    cached = JSON.parse(sessionStorage.getItem('orbeSession') || 'null');
  } catch (error) {}
  var cachedCountry = cached && cached.geolocation && cached.geolocation.countryCode;

  if (productPage) {
    // no automatic popup on product pages, whatever the visitor's country
    window.mdApp_forceHideOrbe = true;
  } else if (cachedCountry || preview) {
    // Orbe will decide synchronously while it loads: decide now
    if (!allowed(cachedCountry)) window.mdApp_forceHideOrbe = true;
  } else if (!wrapProcessGeolocation()) {
    var orbeScript = document.querySelector('script[src*="orbe.min.js"]');
    if (orbeScript) orbeScript.addEventListener('load', wrapProcessGeolocation);
  }

  // The redirect itself: the same page on the other store instead of its home page.
  // Orbe's own query string (?country=XX, which the other store's Orbe reads) is kept.
  window.addEventListener('orbe:before-redirect', function (event) {
    var detail = event.detail;
    if (!detail || typeof detail.url !== 'string') return;
    var from;
    try {
      from = new URL(detail.url, location.href);
    } catch (error) {
      return;
    }
    var alternate = from.hostname !== here && alternates[from.hostname];
    if (!alternate) return;
    var to = new URL(alternate);
    to.search = from.search;
    to.hash = from.hash;
    detail.url = to.href;
  });
})();
